const PT = require("prop-types");
const React = require("react");
const createReactClass = require("create-react-class");
const _ = require("lodash");

const URLMake = require("../../shared/URLMake");
const withOfficeErrorCatching = require("../core/hoc/withOfficeErrorCatching");
const withSetURL = require("../core/hoc/withSetURL");
const ReportClassBody = require("./ReportClassBody");
const SortableTable = require("./SortableTable");
const StatsIcon = require("../core/view/StatsIcon");
const ClassesUtil = require("./util/ClassesUtil");
const Link = require("../core/view/Link");
const CopyTable = require("./data/CopyTable");
const InfoIcon = require("../office/InfoIcon");
const OpsSchool = require("./vault/OpsSchool");
const ReportUtil = require("../../shared/ReportUtil");
const {getDisplayedGradeLabel} = require("../../shared/SchoolUtil");

const styles = require("./styles/ReportClasses.css");

// Helper to apply higher-order components.
const augment = function(Component) {
	Component = withOfficeErrorCatching(Component);
	Component = withSetURL(Component);
	return Component;
};

module.exports = augment(
	createReactClass({
		displayName: "ReportClasses",

		propTypes: {
			user: PT.object.isRequired,
			pageData: PT.object,
			classes: PT.object.isRequired,
			filters: PT.object,
			updateFilter: PT.func,
			schoolState: PT.object.isRequired,

			// Injected by HOCs
			setURL: PT.func.isRequired,
		},

		getClassGradeString: function(classes, classID) {
			return _.toString(_.get(classes, [classID, "gradeID"]));
		},

		filterBy: function(col, val) {
			const {pageData, updateFilter} = this.props;
			const filters = {
				grade: pageData.grade || null,
				chapter: pageData.chapter || null,
				block: pageData.block || null,
				typeID: pageData.typeID || null,
				labBlockID: pageData.labBlockID || null,
				bookTest: null,
			};

			if (col === "days") {
				if (filters.days !== val) {
					updateFilter("days", val);
				}
			} else if (filters[col] !== parseInt(val)) {
				filters[col] = val;
				if (col === "grade") {
					filters.chapter = null;
					filters.block = null;
					filters.typeID = null;
					filters.labBlockID = null;
				} else if (col === "chapter") {
					if (ClassesUtil.isFilterForBookTest({chapter: val})) {
						filters.bookTest = val.slice(8);
						filters.chapter = null;
					} else if (filters.grade === "lab") {
						filters.typeID = val;
						filters.chapter = null;
						filters.labBlockID = null;
					}
					filters.block = null;
				} else if (col === "block" && filters.grade === "lab") {
					filters.labBlockID = val;
					filters.block = null;
				}
				this.props.setURL(
					URLMake.forSchool(
						"reports",
						"classes",
						_.extend({}, pageData, filters)
					)
				);
			}
		},

		renderTable: function(classes) {
			const {days, yearFilter} = this.props.filters;
			const classesArr = [];
			const columnNames = [
				"name",
				"level",
				"grade",
				"teacher",
				"student",
				"star",
				"trophy",
				"pc",
				"time",
			];
			let activeClasses = classes;
			if (
				OpsSchool.getPurchaseYear(this.props.schoolState) ===
				parseInt(yearFilter)
			) {
				activeClasses = _.filter(classes, "activeAndCurrent");
			}
			_.each(activeClasses, c => {
				const totalStats = ReportUtil.totalClassStats(c.students[days]);
				const teachers = _.compact(c.teachers);
				const teacherText = ClassesUtil.getListDisplay(teachers, "lastName");
				const minutes = (totalStats.timeSpent || 0) / 60;
				const rowData = {
					name: (
						<Link
							to={URLMake.forSchool("reports", "classes", {
								classID: c.classID,
							})}
							className={styles.link}
						>
							{c.displayName}
						</Link>
					),
					nameValue: c.displayName,
					level: c.gradeID,
					grade: getDisplayedGradeLabel(c.displayedGrade),
					gradeSort: c.displayedGrade,
					teacher: teacherText,
					student: c.activeStudentIDs.length,
					star: totalStats.stars || 0,
					trophy: totalStats.trophies || 0,
					pc: totalStats.problemsCorrect || 0,
					time: ClassesUtil.timeToShortString(minutes),
					inactive: !c.activeAndCurrent,
				};
				classesArr.push(rowData);
			});

			const headers = {
				name: "Class Name",
				level: "BA Level",
				grade: "Grade",
				teacher: "Teacher",
				student: "Active Students",
				star: (
					<StatsIcon type="star" style="office" className={styles.iconHeader} />
				),
				trophy: (
					<StatsIcon
						type="trophy"
						style="office"
						className={styles.iconHeader}
					/>
				),
				pc: (
					<StatsIcon
						type="check"
						style="office"
						className={styles.iconHeader}
					/>
				),
				time: (
					<StatsIcon type="time" style="office" className={styles.iconHeader} />
				),
			};

			const copy = CopyTable.getReportHeaderCopy("list");
			const categories = (
				<div className={styles.categoriesClasses + " header-reportClassesList"}>
					<div className={styles.tbLeft + " " + styles.totals4}>
						<div className={styles.infoHeader}>
							<InfoIcon
								title={copy.total.title}
								text={copy.total.text}
								className={styles.infoIcon}
								isModal={true}
								modalClass={styles.infoModal}
								modalTextClass={styles.infoModalText}
							/>
							{copy.total.title}
						</div>
					</div>
				</div>
			);

			const sortFunctions = {
				time: body => {
					return _.sortBy(body, [
						"inactive",
						r => ClassesUtil.timeStringToSeconds(r["time"]),
					]);
				},
				played: body => {
					return _.sortBy(body, [
						"inactive",
						r => ClassesUtil.getSortableDate(r["played"]),
					]);
				},
				name: body =>
					_.sortBy(body, ["inactive", r => _.toLower(_.trim(r.nameValue))]),
				grade: body =>
					_.sortBy(body, [
						"inactive",
						r => (r.gradeSort != null ? r.gradeSort : -1),
					]),
			};

			const headerClasses = {
				star: styles.statHeader + " " + styles.tbLeft,
				trophy: styles.statHeader,
				pc: styles.statHeader,
				time: styles.statHeader,
			};
			const bodyClasses = {
				played: styles.statPlayed,
				star: styles.statStar + " " + styles.tbLeft,
				trophy: styles.statTrophy,
				pc: styles.statPC,
				time: styles.statTime,
			};

			const widthClasses = {
				name: styles.nameWidth,
				level: styles.gradeWidth,
				grade: styles.gradeWidth,
				teacher: styles.teacherWidth,
				student: styles.studentWidth,
				star: styles.starWidth,
				trophy: styles.trophyWidth,
				pc: styles.pcWidth,
				time: styles.timeWidth,
			};

			return (
				<div className={styles.body}>
					<SortableTable
						tableID="reportClassesList"
						columnNames={columnNames}
						headers={headers}
						sortableColumns={columnNames}
						initiallySortedBy="name"
						data={classesArr}
						sortFunctions={sortFunctions}
						bodyClasses={bodyClasses}
						headerClasses={headerClasses}
						widthClasses={widthClasses}
						extraHeader={categories}
						canScroll={true}
						grayOutInactive={true}
					/>
				</div>
			);
		},

		render: function() {
			// Only show class data for current and future classes. This is
			// because showing past classes will show current student data
			// anyways. Data is not restricted to the class.
			// We do show old classes for admins.
			const staffRoles = _.get(this.props.user, "model.staffRoles");
			const filteredClasses = _.filter(this.props.classes, c => {
				if (staffRoles.adminPurchase) return true;
				if (staffRoles.adminSchoolIDs.length) {
					return _.includes(staffRoles.adminSchoolIDs, c.school.id);
				} else {
					return c.year >= c.purchaseYear;
				}
			});
			const classes = _.keyBy(filteredClasses, cd => cd.classID);
			const pageData = this.props.pageData || {};
			let body = null;
			const {
				classID,
				grade,
				chapter,
				block,
				bookTest,
				typeID,
				labBlockID,
			} = pageData;
			if (classID) {
				body = (
					<ReportClassBody
						user={this.props.user}
						classID={classID}
						gradeNumber={grade}
						blockNumber={block}
						chapterNumber={chapter}
						bookTest={bookTest}
						typeID={typeID}
						labBlockID={labBlockID}
						pageData={pageData}
						updateClassFilter={this.filterBy}
						classesData={classes}
					/>
				);
			} else {
				body = this.renderTable(classes);
			}
			return <div className={styles.inner}>{body}</div>;
		},
	})
);
